<template>
<div class="presupuestoCard">
    <el-card>
        <div class="cardBody">

          <el-row>
            <el-col :span="2">
            <div :class="opened ? 'triangleDown' : 'triangleRight'" v-on:click="toggleOpen"></div>
            </el-col>
            <el-col :span="18">
              <div class="nroPresupuesto">{{$t('PRESUPUESTO_numero_presupuesto')}}: {{presupuesto.Numero}}</div>
            </el-col>
            <el-col :span="4" class="contenedorIconos">
              <div class='iconContainer' @click="editar" v-show="ingresado">
                <el-tooltip class="item" effect="dark" :content="$t('GENERAL_editBtn')" placement="left">
                  <el-icon><Edit /></el-icon>
                </el-tooltip>
              </div>
              <div class='iconContainer' @click="detalle">
                <el-tooltip class="item" effect="dark" :content="$t('PRESUPUESTO_detalles')" placement="right">
                  <el-icon><Tickets /></el-icon>
                </el-tooltip>
              </div>
              <div class="iconContainer iconDelete" v-show="ingresado" @click="eliminar">
                  <el-tooltip class="item" effect="dark" :content="$t('GENERAL_deleteBtn')" placement="right">
                      <el-icon><Delete /></el-icon>
                  </el-tooltip>
                </div>
            </el-col>
          </el-row>

          <el-row type="flex" justify="end">
              <el-col :span="10" class="label blackLabel">{{$t('PRESUPUESTO_razon_social')}}:</el-col>
              <el-col :span="presupuesto.Instancia !== '0P' ? 13 : 14" class="greyLabel">{{presupuesto.Empresa}}</el-col>
              <!--Boton descargar Reporte-->
              <el-col :span="1" class="contenedorIconos" v-if="presupuesto.Instancia !== '0P'">
                <div class="iconContainer" @click="descargarReporte">
                  <el-tooltip class="item" :content="$t('PRESUPUESTO_descargar_reporte')" effect="dark" placement="left-start">
                  <el-icon v-if="!estaDescargando"><Download /></el-icon>
                  <el-icon v-else class="is-loading primary"><Loading /></el-icon>
                </el-tooltip>
                </div>
              </el-col>
          </el-row>

          <el-row>
              <el-col :span="10" class="label blackLabel">{{$t('GENERAL_fecha')}}:</el-col>
              <el-col :span="10" class="greyLabel">{{presupuesto.FechaStr}}</el-col>
          </el-row>

          <el-row>
                <el-col :span="10" class="label blackLabel">{{$t('PRESUPUESTO_importe_final')}}:</el-col>
                <el-col :span="10" class="greyLabel">{{ decimalToString(presupuesto.ImporteTotal) }}</el-col>
          </el-row>

          <transition name="fade">
            <div v-show="opened">
              <el-row>
                  <el-col :span="10" class="label blackLabel">{{$t('PRESUPUESTO_instancia')}}:</el-col>
                  <el-col :span="10" class="greyLabel">{{descripcionInstancia}}</el-col>
              </el-row>
            </div>
          </transition>
        </div>
      </el-card>
  </div>
</template>

<script>
import { decimalToString } from '../Helpers/commonFunctions'
import i18n from "../../plugins/i18n";
import { mapState } from "vuex";

export default {
  name: "presupuestoCard",
  props: {
    presupuesto: Object,
    },
  data() {
    return {

      activeNames: ["1"],
      opened: false,
      ingresado: false,
      descargando: false,

    };
  },

  methods:
  {
    decimalToString: decimalToString,

    toggleOpen() {
      this.opened = !this.opened
    },
    editar() {
      this.$emit('editar', this.presupuesto.Id)
    },
    detalle() {
      this.$emit('detalle', this.presupuesto.Id)
    },
    eliminar(){
      this.$emit('eliminar', this.presupuesto.Id)
    },
    presupuestoInstancia(){
      if(this.presupuesto.Instancia == ("0P"))
        this.ingresado = true
    },
    descargarReporte(){
      this.descargando = true;
      let idioma = i18n.locale;
        this.$store.dispatch("presupuestos/descargarPresupuesto", { idPresupuesto: this.presupuesto.Id, idUsuario: this.idUsuario, idioma: idioma })
        .then(response =>
        {
          let link = document.createElement('a')
          link.href = "data:application/pdf" + ";base64," + encodeURIComponent(response.Datos)
          link.target = '_blank';
          link.setAttribute('download', this.$t('PRESUPUESTO_pedido') +"_" + this.presupuesto.Numero);
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .finally(() => this.descargando = false);
    },
  },
  mounted() {
    this.presupuestoInstancia();
  },
  computed: {
     ...mapState({
    idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario,
    }),
    descripcionInstancia() {
        let descripcion = ''

        switch(this.presupuesto.Instancia)
        {
          case '0P':
            descripcion = this.$t('PRESUPUESTO_instancia_ingresado')
            break

          case 'ZP':
            descripcion = this.$t('PRESUPUESTO_instancia_historico')
            break

          default:
            descripcion = ''
        }

        return `(${this.presupuesto.Instancia}) ${descripcion}`
      },
      estaDescargando()
      {
        return this.descargando;
      }
  }
}
</script>

<style>
.el-card__body {
  min-height: 42px;
}
</style>

<style scoped>


.triangleRight,
.triangleDown {
  width: 0;
  height: 0;
  border-style: solid;
  cursor: pointer;
}
.triangleRight {
  border-width: 8px 0 8px 13.9px;
  border-color: transparent transparent transparent var(--main-color);
}
.triangleDown {
  border-width: 13.9px 8px 0 8px;
  border-color: var(--main-color) transparent transparent transparent;
}

.verDetalles {
  color:var(--main-color);
  text-align: right;
  font-size: 13px ;
  font-weight: normal;
}

.greyLabel {
  color: #6B6B6B;
  font-weight: normal;
  text-align: left;
  font-size: 14px;
}

.blackLabel {
  font-size: 14px;
  color: black;
  text-align: left;
  font-weight: bold;
}

.label {
  text-align: left;
  margin-bottom: 4px;

}

.nroPresupuesto{
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  margin-bottom: 5px;
}

.seleccionador {
    width: 100%;
    padding: 0;
}

.btn-nuevo {
  padding-right:0%;
  text-align:right;
}

.iconContainer {
  cursor: pointer;
  font-size: 19px;
  margin-left: 4px;
}

.contenedorIconos {
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 600px) {
  .cardBody {
    flex-direction: column;
  }
}

.card_list_item {
  position: relative;
}
.presupuestoCard {
  width: 100%;
}

</style>
